<template>
  <div class="content" id="container"></div>
</template>
<script>
import { exchangeZfqCode } from '@/service/system/exchange-code'
export default {
  data() {
    return {
      content: ''
    }
  },
  created() {
    console.log(window.PalauAPI)
  },
  mounted() {
    const { url, appid } = this.$route.query
    const that = this
    if (url && appid) {
      setTimeout(() => {
        that.getUrl(url, appid)
      }, 300)
    }
  },
  methods: {
    getUrl(url, appid) {
      const that = this
      window.PalauAPI.user.login((val) => {
        if (parseInt(val) === -1 || parseInt(val) === 1) {
          let userInfo = window.PalauAPI.user.userInfo()
          if (!userInfo.uid) {
            window.PalauAPI.dispatch('native://login/?act=index')
          } else {
            //登录了
            that.access_token = userInfo.access_token
            exchangeZfqCode({
              accessToken: userInfo.access_token,
              xinjianAppId: appid,
              redirectUrl: decodeURIComponent(url),
              confirmCover: '0'
            })
              .then((res) => {
                console.log(666, res.redirectUrl)
                location.replace(res.redirectUrl)
                console.log(res)
              })
              .catch((err) => {
                console.log(err)
              })
          }
        } else {
          window.PalauAPI.back()
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped></style>
